module.exports = __webpack_public_path__ + "static/media/finPicOne.3f51d5fd.jpg";